import { render, staticRenderFns } from "./redesign.vue?vue&type=template&id=616eda02&scoped=true&"
import script from "./redesign.vue?vue&type=script&lang=js&"
export * from "./redesign.vue?vue&type=script&lang=js&"
import style1 from "./redesign.vue?vue&type=style&index=1&id=616eda02&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616eda02",
  null
  
)

export default component.exports